import { AxiosResponse } from 'axios';
import { AttainmentServiceResponse } from 'types/interfaces/Attainment';

import { api } from '../../http';
import {
  BaseFilter,
  PageRequest,
  PageResponse,
  SkillAndCertification
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const AttainmentService = {
  getAttainments(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<ApiResponse<PageResponse<SkillAndCertification>>>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api.get<ApiResponse<PageResponse<SkillAndCertification>>>('attainment', {
      params: searchParams
    });
  },

  getAttainmentById(id: number): Promise<AxiosResponse<ApiResponse<SkillAndCertification>>> {
    return api.get<ApiResponse<SkillAndCertification>>(`attainment/${id}`);
  },

  updateAttainment(
    id: number,
    skillAndCertification: SkillAndCertification
  ): Promise<AxiosResponse<ApiResponse<SkillAndCertification>>> {
    return api.put<ApiResponse<SkillAndCertification>>(
      `attainment/${id}`,
      skillAndCertification
    );
  },

  deleteAttainment(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`attainment/${id}`);
  },

  createAttainment(
    skillAndCertification: SkillAndCertification
  ): Promise<AxiosResponse<ApiResponse<SkillAndCertification>>> {
    return api.post<ApiResponse<SkillAndCertification>>('attainment', skillAndCertification);
  },

  getAttainmentsForSelection(): Promise<AxiosResponse<AttainmentServiceResponse>> {
    return api.get<AttainmentServiceResponse>('attainment', {
      params: { ForSelection: 'true' }
    });
  }
};
